import restGql from 'graphql-tag';

export const ValidateBillingPlan = restGql`#graphql
    mutation ValidateBillingPlan(
        $input: ValidateBillingPlanQueryVariables!
    ) {
        validateBillingPlan(input: $input) @rest(
            type: "ValidateBillingPlan", 
            method: "POST",
            path: "/v2/plans?preview=true&version=2",
            bodyKey: "input"
        ) {
            plan {
                id
                childId
                behaviors {
                    id
                    payload {
                        warnings {
                            message
                            error
                            severity
                            title
                            metadata
                        }
                    }
                }
            }
        }
    }   
`;
